/* Woodmobiel — generieke afbeelding-lightbox (bouwhulp-instructiefoto's) */
(function(){
  function init(){
    var ov = document.querySelector('[data-wm-lb]');
    if(!ov) return;
    var img = ov.querySelector('[data-wm-lb-img]');
    var cap = ov.querySelector('[data-wm-lb-cap]');
    function open(el){
      img.src = el.getAttribute('data-img') || '';
      img.alt = el.getAttribute('data-name') || '';
      if(cap) cap.textContent = el.getAttribute('data-cap') || '';
      ov.classList.add('is-open'); ov.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden';
    }
    function close(){ ov.classList.remove('is-open'); ov.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
    document.addEventListener('click', function(e){
      var card = e.target.closest && e.target.closest('[data-wm-lightbox]');
      if(card){ e.preventDefault(); open(card); return; }
      if(e.target.closest && e.target.closest('[data-wm-lb-close]')){ close(); }
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') close(); });
  }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
